import { render, staticRenderFns } from "./portalLayout.vue?vue&type=template&id=2c52ff6a&scoped=true&"
import script from "./portalLayout.vue?vue&type=script&lang=js&"
export * from "./portalLayout.vue?vue&type=script&lang=js&"
import style0 from "./portalLayout.vue?vue&type=style&index=0&id=2c52ff6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52ff6a",
  null
  
)

export default component.exports